<template>
  <div class="content">
    <div class='content_w'>
      <div v-show='trainingRoomList.length!==0 ||  keyword!==""' class="header ">
        <div class="search selection">
          <a-input v-model="keyword" @change="search" :placeholder="$t('search.placeholder')">
            <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
            <img
              class="clear"
              v-if="keyword"
              slot="suffix"
              @click=";(keyword = undefined), search()"
              :src="require('@/assets/icons/icon_gb.png')"
            />
          </a-input>
          <div class="search_text"><span></span>{{ $t('search.searchText') }}</div>
        </div>
        <div class="appointment_right">
          <a-button :style="{ cursor: time == newDate ? 'no-drop' : '' }" :disabled="time == newDate" @click="changeTime(1)" icon="left" />
          <span class="date">
            <a-date-picker
              format="MM.DD"
              :disabled-date="disabledDate"
              :disabled-time="disabledDateTime"
              :allowClear="false"
              suffix-icon=" "
              v-model="time"
              @change="onChange"
            >
            </a-date-picker>
          </span>
          <a-button @click="changeTime(2)" icon="right" />
          <a-button :style="{ cursor: time == newDate ? 'no-drop' : '' }" :disabled="time == newDate" @click="changeTime(0)" style="margin-left: 10px;">{{ $t('room.today') }}</a-button>
        </div>
      </div>

      <!-- Room List -->
      <div class="main">
        <div class="list" v-for="(item, index) in trainingRoomList" :key="index">
          <div class="flex item" @mouseenter="mouseoutShow(index)" @mouseleave="mouseoutHide(index)">
            <div class="item_left">
              <div class="flex item_left_top">
                <div class="item_left_top_name">
                  <a-tooltip placement="topLeft" :title="item.name">
                    {{ item.name }}
                  </a-tooltip>
                </div>
                <div class="item_left_top_tip" v-show="item.isReview == '1'">
                  {{ $t('room.needApproval') }}
                </div>
              </div>
              <div class="underline"></div>
              <div class="flex item_left_bottom">
                <div class="num">
                  <img src="@/assets/icons/icon_r@2x.png" alt="" />
                  <span>{{ item.number }}</span>
                </div>
                <div class="location">
                  <img src="@/assets/icons/icon_dw@2x.png" alt="" />
                  <a-tooltip placement="bottom">
                    <template slot="title">
                      <span>{{ item.place }}</span>
                    </template>
                    <span>{{ item.place }}</span>
                  </a-tooltip>
                </div>
              </div>
            </div>
            <div class="flex item_right">
              <div class="timeline">
                <div class="flex axis">
                  <template v-for="timeInfo in item.timerShaftList">
                    <template  v-if='timeInfo.self==true && timeInfo.status!==4 && timeInfo.over && timeInfo.className.includes("gray")==false'>
                      <a-popover >
                        <template slot="content" >
                          <div class='popover'>
                            <div v-if='timeInfo.status==1' class='status1'>{{ $t('status.pending') }}</div>
                            <div v-else-if='timeInfo.status==2'>{{ $t('status.approved') }}</div>
                            <div v-else-if='timeInfo.status==3' class='status3'>{{ $t('status.rejected') }}</div>
                            <div @click='popDetail(timeInfo)'><span>{{ timeInfo.theme }}</span><img src="@/assets/icons/icon_j@2x.png" alt=''></div>
                            <div><img src="@/assets/icons/icon_sj@2x.png" alt=''>{{ timeInfo.time }}</div>
                            <div>
                              <a-button class='popover_btn' type="primary" @click='popReserve(timeInfo,item)'>
                                <span v-if='timeInfo.status==1|| timeInfo.status==2'>{{ $t('appointment.cancel') }}</span>
                                <span v-else>{{ $t('appointment.reappoint') }}</span>
                              </a-button>
                            </div>
                          </div>
                        </template>
                        <div
                          :class="['axis_item', timeInfo.className ? timeInfo.className : '']"
                          :key="timeInfo.eTimestamp"
                          @mouseenter="handleMouseEnter(timeInfo)"
                        >
                          <div class="paragraph">
                            <template v-if="timeInfo.curTime">
                              <img
                                v-if="timeInfo.curTime"
                                :src="hourMark[timeInfo.hourMark]"
                                alt=""
                              />
                            </template>
                            <div>{{ timeInfo.curTime }}</div>
                          </div>
                        </div>
                      </a-popover>
                    </template>
                    <template  v-else>
                      <template slot="content"  v-if='timeInfo.self==true && timeInfo.status!==4' >
                        <div class='popover'>
                          <div>{{ $t('status.pending') }}</div>
                          <div><span>{{ timeInfo.theme }}</span><img src="@/assets/icons/icon_j@2x.png" alt=''></div>
                          <div><img src="@/assets/icons/icon_sj@2x.png" alt=''>{{ timeInfo.time }}</div>
                          <div>
                            <a-button class='popover_btn' type="primary">
                              {{ $t('appointment.cancel') }}
                            </a-button>
                          </div>
                        </div>
                      </template>

                      <div
                        :class="['axis_item', timeInfo.className ? timeInfo.className : '']"
                        :key="timeInfo.eTimestamp"
                        @mouseenter="handleMouseEnter(timeInfo)"
                      >
                        <div class="paragraph">
                          <template v-if="timeInfo.curTime">
                            <img
                              v-if="timeInfo.curTime"
                              :src="hourMark[timeInfo.hourMark]"
                              alt=""
                            />
                          </template>
                          <div>{{ timeInfo.curTime }}</div>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
              <div class="action" >
                <a-button v-show='item.buttonState' type="primary" :disabled="item.disabled" @click="reserveClick(item)">
                  <span>{{ $t('appointment.appointmentBtn') }}</span><a-icon type="right" />
                </a-button>
              </div>
            </div>
          </div>
        </div>

        <!-- No Data -->
        <div v-if="trainingRoomList.length === 0" class="nodata">
          <img src="@/assets/img/bj_zanwushujv.png" alt="" />
          <div>
            <div class="text">{{ $t('noDataEmpty') }}</div>
            <div class='search_null' v-show='searchNull'>{{ $t('search.tryOtherKeyword') }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Appointment Modal -->
    <a-modal :title="$t('appointment.title')" width="515px" :visible="editShow" @ok="submitEdit" @cancel="editShow = false">
      <a-form :form="formEdit">
        <div class="list list_flex">
          <a-form-item :label="$t('appointment.roomName')">
            <a-input class="wd205" disabled v-decorator="['name']" />
          </a-form-item>
          <a-form-item :label="$t('appointment.location')">
            <a-input class="wd205" disabled v-decorator="['place']" />
          </a-form-item>
        </div>
        <a-form-item :label="$t('appointment.useTitle')">
          <a-input
            allowClear
            :maxLength="30"
            v-decorator="['theme', { rules: [{ required: true, message: $t('appointment.useTitleRequired') }] }]"
            :placeholder="$t('appointment.useTitlePlaceholder')"
          />
        </a-form-item>
        <a-form-item class="full" :label="$t('appointment.appointmentTime')" required :colon="false">
          <div class="list_flex">
            <div class="wd205">
              <a-form-item class="wd205">
                <a-time-picker
                  class="wd205"
                  @change="onChangeStart"
                  :default-open-value="moment(startTimeAlert, 'HH:mm')"
                  v-decorator="['startTime', { rules: [{ required: true, message: $t('appointment.startTimeRequired') }] }]"
                  format="HH:mm"
                  :minute-step="15"
                  :disabledHours="StartHours"
                  :disabledMinutes="checkoutMin"
                  :hideDisabledOptions="true"
                />
              </a-form-item>
            </div>
            <div style="margin: 0 10px">
              -
            </div>
            <div class="wd205">
              <a-form-item class="wd205">
                <a-time-picker
                  class="wd205"
                  @change="onChangeEnd"
                  :default-open-value="moment(startTimeAlert, 'HH:mm')"
                  v-decorator="['endTime', { rules: [{ required: true, message: $t('appointment.endTimeRequired') }] }]"
                  format="HH:mm"
                  :minute-step="15"
                  :disabledHours="StartHours"
                  :disabledMinutes="checkoutMin"
                  :hideDisabledOptions="true"
                />
              </a-form-item>
            </div>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- Cancel Confirmation Modal -->
    <TipModal
      @ok="cancle"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`<p>${$t('appointment.confirmCancel')}</p>`"
    />

    <!-- Status Modal -->
    <a-modal
      class="alert_model"
      :title="$t('appointment.title')"
      width="378px"
      :visible="alertShow"
      @cancel="alertShow = false"
    >
      <div class="alert_content">
        <div class="text">
          <p>{{ $t('appointment.roomName') }}:</p>
          <p>{{ popData.name }}</p>
        </div>
        <div class="text">
          <p>{{ $t('appointment.location') }}:</p>
          <p>{{ popData.place }}</p>
        </div>
        <div class="text">
          <p>{{ $t('appointment.useTitle') }}:</p>
          <p>{{ popData.theme }}</p>
        </div>
        <div class="text">
          <p>{{ $t('appointment.appointmentTime') }}:</p>
          <p>{{ popData.startEnd }}</p>
        </div>
        <div class="text">
          <p>{{ $t('reviewStatus.pending') }}:</p>
          <p v-if="popData.status==1" class="status_1">{{ $t('reviewStatus.pending') }}</p>
          <p v-else-if="popData.status==2" class="status_2">{{ $t('reviewStatus.approved') }}</p>
          <p v-else-if="popData.status==3" class="status_3">{{ $t('reviewStatus.rejected') }}</p>
        </div>
        <div class="text" v-if="popData.status==3">
          <p>{{ $t('reviewStatus.reviewComment') }}:</p>
          <p>{{ popData.remark }}</p>
        </div>
      </div>
      <template slot="footer">
        <a-button type="primary" style='margin-bottom:28px' @click="handleOk" v-if="popData.status==3">
          {{ $t('appointment.reappoint') }}
        </a-button><div></div>
      </template>
    </a-modal>

    <div class='pagination_w'>
      <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handlePaginationChange(pagination.page)" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {
  collegeSave,
  getTrainingRoomApplyTrainingRoomList,
  postTrainingRoomApplyCancel,
  postTrainingRoomApplySave
} from '@/api/admin'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'
import Error from '@/views/result/Error.vue';
export default {
  name: 'TrainingAppointment',
  components: { TipModal,Pagination },
  data() {
    return {
      searchNull:false,
      moment,
      startTime: 5,
      startTimeAlert:0,//弹框预约默认开始时间
      time: '',
      // defaultDate:moment(new Date(), 'MM-DD'),
      newDate: '',
      editShow: false,
      formEdit: this.$form.createForm(this),
      startTimeModel: '',
      endTime: '',
      trainingRoomList: [],
      page: 1,
      subDate: '',
      keyword: '',
      id: '',
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      timeSegment: [],
      delVisible: false,
      alertShow: false,
      hourMark: [
        require('@/assets/icons/icon_w@2x.png'),
        require('@/assets/icons/icon_g@2x.png'),
        require('@/assets/icons/icon_x@2x.png'),
        require('@/assets/icons/icon_l@2x.png'),
        require('@/assets/icons/icon_h@2x.png')
      ],
      popData:{},
      reservationId:''
    }
  },

  mounted() {
    this.formattedDate()
    // 列表
    this.getTrainingRoomApplyTrainingRoomListHttp()

  },

  methods: {
    // 取消预约
    del(){

    },
    onVisibleChange(item){
      console.log(item)
    },
    mouseoutShow(index){
      this.trainingRoomList[index].buttonState=true
    },
    mouseoutHide(index){
      this.trainingRoomList[index].buttonState=false
    },
    handleMouseEnter(el){
      this.popData = el
    },
    // 提示框中按钮
    popReserve(item,fs){
      this.popData = item
      // 取消预约
      if(item.status == 1 || item.status == 2){
        this.delVisible = true
        this.reservationId = item.id

      }else{
        // 重新预约
        this.reserveClick(fs)

      }
    },
    popDetail(item){
      this.alertShow=true
    },
    // 取消预约
    postTrainingRoomApplyCancelHttp(id){
      postTrainingRoomApplyCancel(id).then(res => {
        if(res.code == 200){
          this.getTrainingRoomApplyTrainingRoomListHttp()
        }
      })
    },
    // 预约
    reserveClick(item) {
      console.log(1111)
      this.timeSegment = []
      let start = Number(item.startTime.split(':')[0])
      let end = Number(item.endTime.split(':')[0])
      console.log(end)
      this.startTimeAlert = item.startTime
      for (let i = 0; i < start; i++) {
        this.timeSegment.push(i)
      }
      for (let i = end; i < 24; i++) {
        if(i!==end){
          this.timeSegment.push(i)
        }

      }
      console.log(item)

      this.editShow = true
      this.id = item.id
      this.$nextTick(() => {
        this.formEdit.setFieldsValue({
          name: item.name,
          place: item.place,
          theme: '',
          startTime: '',
          endTime: ''
        })
      })
    },
    // 重新预约
    handleOk(){
      this.editShow = true
      this.alertShow = false
      if(this.popData.trainingRoomId!==undefined){
        this.id = this.popData.trainingRoomId
      }else{
        this.id = this.popData.id
      }
      this.$nextTick(() => {
        this.formEdit.setFieldsValue({
          name: this.popData.name,
          place: this.popData.place,
          theme: '',
          startTime: '',
          endTime: ''
        })
      })
    },
    // 取消预约
    cancle() {
      this.delVisible = false
      let id={
        id:this.reservationId
      }
      this.postTrainingRoomApplyCancelHttp(id)

    },
    search: _.debounce(function(event) {
      this.page = 1
      if (event == undefined) {
        this.keyword = ''
      } else {
        this.keyword = event.target.value
      }
      this.getTrainingRoomApplyTrainingRoomListHttp()
    }, 500),
    // 当天
    formattedDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const day = now
        .getDate()
        .toString()
        .padStart(2, '0')
      this.newDate = `${year}.${month}.${day}`
      this.time = `${year}.${month}.${day}`
      console.log( this.time)
      return `${year}.${month}.${day}`
    },
    // 比较时间
    compareTimes(time) {
      if (time !== null) {
        var s = ''
        var hour = time.split(':')[0]
        var min = time.split(':')[1]
        s = Number(hour * 3600) + Number(min * 60)
        return s
      }
    },
    // 下一天
    getNextDay(dateString) {
      let d = dateString.split('.').join('-')
      const date = new Date(d)
      date.setDate(date.getDate() + 1)
      return date
        .toISOString()
        .split('T')[0]
        .split('-')
        .join('.')
    },
    // 上一天
    getPreviousDay(dateString) {
      let d = dateString.split('.').join('-')
      const date = new Date(d)
      date.setDate(date.getDate() - 1)
      return date
        .toISOString()
        .split('T')[0]
        .split('-')
        .join('.')
    },
    // 上一天1 下一天2 今天0
    changeTime(num) {
      if (num == 0) {
        this.time = this.newDate
      } else if (num == 1) {
        if (this.time !== this.newDate) {
          this.time = this.getPreviousDay(this.time)
        }
      } else if (num == 2) {
        this.time = this.getNextDay(this.time)
      }
      this.getTrainingRoomApplyTrainingRoomListHttp()
    },
    disabledDate(current) {
      return current < moment().subtract(1, 'day')
    },
    // 日历
    disabledDateTime() {
      let curDate = d || dayjs()
      let now = dayjs()
      const isSameDay = curDate.isSame(now, 'day')
      const isSameHour = curDate.isSame(now, 'hour')
      const isSameMinute = curDate.isSame(now, 'minute')

      return {
        disabledHours: () => {
          if (isSameDay) {
            return range(0, now.hour())
          }
        },
        disabledMinutes: () => {
          if (isSameHour) {
            return range(0, now.minute())
          }
        },
        disabledSeconds: () => {
          if (isSameMinute) {
            return range(0, now.second())
          }
        }
      }
    },
    // 选择日历时间
    onChange(date, dateString) {
      this.time =  moment(moment(date._d).format('YYYY.MM.DD')).format('YYYY.MM.DD')
      this.getTrainingRoomApplyTrainingRoomListHttp()
    },
    // 预约弹框确定
    submitEdit() {
      console.log(this.id)
      this.formEdit.validateFields(async (err, values) => {
        if (!err) {
          values.startTime = this.startTimeModel
          values.endTime = this.endTime
          const res = await postTrainingRoomApplySave({ ...values, trainingRoomId: this.id, subDate: this.time })
          if (res.code === 200) {
            this.editShow = false
            this.$message.success(this.$t('messages.appointmentSuccess'))
            this.getTrainingRoomApplyTrainingRoomListHttp()
          } else {

          }
        }
      })
    },
    StartHours() {
      // var hours = new Date().getHours();
      // let arr=[]
      // for(let i=0;i<hours;i++){
      //   arr.push(i)
      // }

      return this.timeSegment
    },
    checkoutMin(arr) {
      if (arr == 23) {
        let arr = []
        for (let i = 1; i < 60; i++) {
          arr.push(i)
        }
        return arr
      } else {
        return []
      }
    },
    onChangeStart(el, al) {
      this.startTimeModel = al
      this.formEdit.setFieldsValue({
        endTime: ''
      })
    },
    onChangeEnd(el, al) {
      let str_date = this.startTimeModel
      let endTime = al
        if (this.getDate(str_date) - this.getDate(al) > 0 && al !== '') {
          this.$message.error(this.$t('messages.invalidTime'))
        } else {
          this.endTime = al
        }
    },
    // 时间对比
    getDate(date) {
      let dates = date.split(':')
      let dateReturn = ''
      for (let i = 0; i < dates.length; i++) {
        dateReturn += dates[i]
      }
      return dateReturn
    },
    getTrainingRoomApplyTrainingRoomListHttp() {
      let param = {
        page: this.page,
        subDate: this.time,
        keyword: this.keyword
      }
      getTrainingRoomApplyTrainingRoomList(param).then(res => {
        if (res.code == 200) {
          if (this.time == this.newDate) {
            let hours = new Date().getHours() + ':' + new Date().getMinutes()
            for (let item of res.data.list) {
              if (this.compareTimes(hours) - this.compareTimes(item.endTime) > 0) {
                item.disabled = true
              } else {
                item.disabled = false
              }
            }
          }
          for (let item of res.data.list) {
            item.buttonState=false
          }
          if(this.keyword!=='' && res.data.list.length==0){
            this.searchNull=true
          }else{
            this.searchNull=false
          }
          this.transition(res.data.list)
          this.pagination.total = Number(res.data.total)
        }
      })
    },
    handlePaginationChange(e) {
      this.page = e
      this.getTrainingRoomApplyTrainingRoomListHttp()
    },
    compareTime(time1, time2) {
      const date1 = new Date(time1);
      const date2 = new Date(time2);

      if (date1 < date2) {
        return -1; // time1 is before time2
      } else if (date1 > date2) {
        return 1; // time1 is after time2
      } else {
        return 0; // time1 is equal to time2
      }
    },
    // 预约时间轴数据处理
    transition(list) {
      const timeList = []
      const startTime = 5 // 开始时间 5点
      const paragraphNum = 76 // 段落数
      const interval = 15
      let gettime = this.time.split('.').join('-') +' 05:00:00'
      let startTimestamp = moment(gettime).valueOf()
      const setProperty = (obj, className, hourMark) => {
        const colorList = ['gray', 'orange', 'green', 'red'];
        // 创建正则表达式
        const regex = new RegExp(colorList.join('|'), 'g');
        // 替换字符串
        if(obj.className!==undefined){
          obj.className = obj.className.replace(regex, '');
        }
        obj.className += ' ' + className
        if (obj.hasOwnProperty('hourMark')) {
          obj.hourMark = hourMark
        }
      }
      if (Array.isArray(list)) {
        // 初始化每段起至时间戳
        for (let inx = 0; inx < paragraphNum; inx++) {
          const sTimestamp = startTimestamp
          const eTimestamp = moment(sTimestamp).add(interval, 'minutes').valueOf()
          timeList.push([sTimestamp, eTimestamp])
          startTimestamp = eTimestamp
        }
        // 映射到列表数据中
        list.forEach(item => {
          item.timerShaftList = timeList.map((item, inx) => {
            const result = {
              sTimestamp: item[0],
              eTimestamp: item[1]
            }
            // 整点标识
            if ((inx + 1) % 4 === 0 && (inx + 1) !== paragraphNum) {
              result.hourMark = 0 // 0 默认 1 已预约 2 待审核 3 已通过 4 已拒绝
              result.curTime = moment(item[1]).hour() + ':' + String(moment(item[1]).minute()).padStart(2, '0')
            }
            if (inx === 0) {
              result.className = 'rounded-l'
            }
            if (inx === timeList.length - 1) {
              result.className = 'rounded-r'
            }
            return result
          })
        })
        // 匹配区间
        list.forEach(item => {

          if (Array.isArray(item.applyList)) {
            item.applyList.reverse().forEach(a => {
              if (a.startTime && a.endTime) {
                try {
                  const startTime = a.startTime.split(':')
                  const endTime = a.endTime.split(':')
                  const sTimestamp = moment( this.time.split('.').join('-')+' '+a.startTime+':00').valueOf()
                  const eTimestamp = moment( this.time.split('.').join('-')+' '+a.endTime+':00').valueOf()

                  item.timerShaftList.forEach((t,index) => {
                    // 不可预约时间
                    if (t.eTimestamp <= moment().valueOf()) {
                      setProperty(t, 'gray', 1)
                    }
                    if (t.sTimestamp >= sTimestamp && t.eTimestamp <= eTimestamp) {
                      if (t.sTimestamp === sTimestamp) {

                        t.className += ' ' + 'rounded-l'
                      }
                      if (t.eTimestamp === eTimestamp) {
                        t.className += ' ' + 'rounded-r'
                      }
                      t.theme=  a.theme
                      t.time = a.startTime +'-'+a.endTime
                      t.status=a.status
                      t.self = a.self
                      t.startEnd=a.startEnd
                      t.teacherId = a.teacherId
                      t.id = a.id
                      t.trainingRoomId = a.trainingRoomId
                      t.remark = a.remark
                      t.place = item.place
                      t.name = item.name
                      let time1 = a.startEnd.substring(0,10)+' '+a.startEnd.substring(17,23)
                      time1 = time1.split('.').join('-')
                      let newTime = moment(moment().format('YYYY-MM-DD HH:mm')).format('YYYY-MM-DD HH:mm')
                      if(this.compareTime(time1,newTime)==-1){
                        t.over = false
                      }else{
                        t.over =true
                      }

                      if (a.self) {
                        switch (a.status) {
                          // 待审核
                          case 1:
                            setProperty(t, 'orange', 2)
                            break
                          // 已通过
                          case 2:
                            setProperty(t, 'green', 3)
                            break
                          // 已拒绝
                          case 3:
                            setProperty(t, 'red', 4)
                            break

                        }
                      } else {
                        // 被预约
                        setProperty(t, 'gray', 1)
                      }
                    }
                    if (t.sTimestamp === sTimestamp) {
                      // if(index-1>0  && t.eTimestamp > moment().valueOf() && a.self){
                      //   if(item.timerShaftList[index-1].hasOwnProperty('hourMark')){
                      //     switch (a.status) {
                      //       // 待审核
                      //       case 1:
                      //         setProperty(item.timerShaftList[index-1], 'orange', 2)
                      //         break
                      //       // 已通过
                      //       case 2:
                      //         setProperty(item.timerShaftList[index-1], 'green', 3)
                      //         break
                      //       // 已拒绝
                      //       case 3:
                      //         setProperty(item.timerShaftList[index-1], 'red', 4)
                      //         break
                      //
                      //     }
                      //
                      //   }
                      // }
                    }
                  })
                } catch (err) {
                  console.log('数据转换错误 ----->', Error)
                }
              }
            })

          }
          // 不可选状态
          const startTime = item.startTime.split(':')
          const endTime = item.endTime.split(':')
          const sTimestamp = moment( this.time.split('.').join('-')+' '+item.startTime+':00').valueOf()
          const eTimestamp = moment( this.time.split('.').join('-')+' '+item.endTime+':00').valueOf()
          let nowTime = moment(moment().format('YYYY-MM-DD HH:mm:ss')).valueOf()
          // let t = '2024-07-30 16:30:03'
          // let nowTime =  moment( t).valueOf()

          item.timerShaftList.forEach(t => {
            if (t.eTimestamp <= sTimestamp || t.eTimestamp < nowTime) {
              setProperty(t, 'gray', 1)
            }else if(t.sTimestamp >= eTimestamp){
              setProperty(t, 'gray', 1)
            }
          })

        })
        this.trainingRoomList = list
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  height: 96.5% !important;
  .content_w{
    height: 100% !important;
    padding: 46px 19px;
    overflow: hidden !important;
  }
  .list-pagination {
    position: absolute;
    bottom: 50px;
    width: calc(100% - 283px);
  }
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .appointment_right {
      margin-bottom: 22px;
      /deep/.ant-input,
      /deep/.ant-input-affix-wrapper {
        font-size: 22px;
        font-weight: bold;
        border: none;
        padding: 0;
        cursor: pointer;
      }

      display: flex;
      align-items: center;
      .date {
        font-size: 22px;
        font-weight: bold;
        margin: 0 18px;
        border: none;
        width: 72px;
        position: relative;
        overflow: hidden;
      }
      /deep/.ant-btn {
        padding: 0 9px;
      }
    }
  }
  .selection {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 22px;
    justify-content: space-between;
    /deep/.ant-input,
    /deep/.ant-input-affix-wrapper {
      width: 367px;
      height: 35px;
      color: #000;
      margin-right: 30px;
      border-radius: 20px;
      padding-right: 59px;
      .ant-input-prefix,
      .ant-input-suffix {
        > img {
          width: 16px;
          cursor: pointer;
        }
      }
      .ant-input-suffix .clear {
        width: 14px;
        height: 14px;
        margin-right: 61px;
      }
    }
  }
  .list {
    .item {
      height: 115px;
      border: solid 1px #d8dce0;
      border-radius: 4px;
      padding: 25px 20px;
      box-sizing: border-box;
      margin-top: 22px;
      cursor: pointer;
      .item_left {
        min-width: 275px;
        .item_left_top {
          justify-content: flex-start;
          .item_left_top_name {
            font-weight: 600;
            font-size: 18px;
            color: #000000;
            max-width: 180px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .item_left_top_tip {
            background: #fff1e8;
            color: #f27529;
            padding: 5px 10px;
            border-radius: 4px;
            font-size: 12px;
            margin-left: 12px;
          }
        }
        .underline {
          width: 27px;
          height: 4px;
          border-radius: 4px;
          background: #ef623d;
          margin: 10px 0;
        }
        .num {
          font-size: 14px;
          color: #000000;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
        span{
          vertical-align: text-top;
        }
        .item_left_bottom {
          font-size: 12px;
          justify-content: flex-start;
          img {
            width: 20px;
            height: 16px;
            padding-right: 4px;
          }
          .location {
            width: 120px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-left: 20px;
            font-size: 14px;
            color: #000000;
          }
        }
      }
      .item_right {
        width: calc(100% - 275px);
        height: 100%;
        .timeline {
          flex: 1;
          height: 100%;
          margin: 47px 30px 0 30px;
          overflow-x: auto;
          padding-top: 3px;
          .axis {
            min-width: 1140px;
            height: 10px;
            background: #eceff2;
            justify-content: flex-start;
            border-radius: 10px;
            // overflow: hidden;
            &>div:first-child{
               border-top-left-radius: 10px;
             border-bottom-left-radius: 10px;
            }
            &>div:last-child{
              border-top-right-radius: 10px;
              border-bottom-right-radius: 10px;
            }
            .axis_item {
              width: 1.3157%;
              height: 8px;
              border-right: solid 1px #d8dce0;
              position: relative;
              .paragraph {
                width: 40px;
                text-align: center;
                position: absolute;
                top: -9px;
                left: -5px;
                z-index: 99;
                img {
                  width: 13px;
                }
              }
            }
            .outmoded {
              background: linear-gradient(180deg, #f0f0f0 0%, #c4c4c4 100%) !important;
            }
            .booked {
              background: linear-gradient(180deg, #ffbd8c 0%, #ff7108 100%) !important;
            }
            .gray {
              background: linear-gradient( 180deg, #F0F0F0 0%, #C4C4C4 100%) !important;
            }
            .orange {
              background: linear-gradient( 180deg, #FFC193 0%, #FF6D00 100%) !important;
            }
            .green {
              background: linear-gradient(180deg, #1EEDA8 0%, #2CB375 100%) !important;
            }
            .red {
              background: linear-gradient( 180deg, #FF8A94 0%, #FF5967 100%) !important;
            }
            .rounded {
              border-radius: 10px;
            }
            .rounded-l {
             /* border-top-left-radius: 10px;
              border-bottom-left-radius: 10px;*/
            }
            .rounded-r {
              //border-top-right-radius: 10px;
              //border-bottom-right-radius: 10px;
            }
          }
          /* 水平滚动条 */
          &::-webkit-scrollbar {
            height: 4px;
          }
          // &::-webkit-scrollbar-track {
          //     background-color: #f8f6f6;
          // }
          &::-webkit-scrollbar-thumb:hover {
            background-color: #d8d6d6;
            cursor: pointer;
          }
        }
        .action {
          min-width: 87px;
          /deep/ .anticon-right {
            color: #fff;
          }
        }
      }
    }
  }
  .item:hover {
    border: solid 1px #f99015;
  }
}
.nodata {
  display: flex;
  align-items: center;
  padding-bottom: 70px;
  justify-content: center;
  flex-direction: column;
  height: calc(100% - 0px);
  img {
    width: 285px;
    margin-bottom: 12px;
  }
  > div {
    width: 100%;
    display: flex;
    margin-top: -70px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .text {
      font-weight: 550;
      color: #0d2340;
      margin-bottom: 5px;
    }
  }
  .search_null{
    font-weight: 400;
    font-size: 12px;
    color: #0D2340;
  }
}
.main {
  position: relative;
  height: calc(94%);
  overflow-y: auto;
}
/deep/.anticon-calendar .ant-calendar-picker-icon {
  display: none !important;
}

.search {
  position: relative;
  .search_text {
    position: absolute;
    top: 6px;
    right: 41px;
    display: flex;
    z-index: 5;
    cursor: pointer;
    span {
      display: inline-block;
      width: 1px;
      height: 10px;
      background: #e9e9e9;
      margin-right: 8px;
      margin-top: 6px;
    }
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
}

.wd205 {
  width: 205px;
}
.list_flex {
  display: flex;
  justify-content: space-between;
}
/deep/ .list_flex .ant-form-item {
  margin-bottom: 6px;
}
.alert_content {
  .text {
    display: flex;
  }
  .text p:nth-child(1) {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    margin-right: 10px;
    display: inline-block;
    min-width: 74px;
  }
  .text p:nth-child(2) {
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.alert_model {
  /deep/ .ant-btn {
    display: none;
  }
  /deep/ .ant-btn-primary {
    display: block !important;
  }
}

.popover {
  width: 190px;
  position: relative;
}
.popover>div:nth-child(1){
  position: absolute;
  left: -16px;
  top: 0px;
  width: 51px;
  height: 23px;
  line-height: 23px;
  text-align: center;
  background: #E2F1EC;
  border-radius: 0px 12px 12px 0px;
  margin-bottom: 8px;
  font-weight: 400;
  font-size: 11px;
  color: #00A981;
}
.status1{
  background: #FBEADB !important;
  color: #FF6D00 !important;
}
.status3{
  background: #FFECEC !important;
  color: #FF5967 !important;
}
.popover>div:nth-child(2) {
  cursor: pointer;
  span{
    display: inline-block;
    max-width: 160px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 8px;
    vertical-align: text-top;
  }
  padding-top: 34px;
  font-weight: 500;
  font-size: 14px;
  color: #000000;

  img{
    width: 7px;
    height: 13px;
    margin-left: 5px;
  }

}
.popover>div:nth-child(3) {
  font-weight: 500;
  font-size: 14px;
  color: #617084;
  margin-bottom: 10px;
  img{
    width: 14px;
    height: 14px;
    margin-right: 5px;
    margin-bottom: 2px;
    vertical-align: sub;
  }
}
.popover>div:nth-child(4) {
  margin-bottom: 2px;
  text-align: center;
}
.alert_model /deep/.ant-modal-wrap .ant-modal .ant-modal-footer{
  padding-bottom:0px
}
.status_1{
  color: #FF5967 !important;
}
.status_2{
  color: #00A981 !important;
}
.status_3{
  color: #FF6D00 !important;
}
/deep/.ant-input::-webkit-input-placeholder{
  padding-left: 8px;
}
.pagination_w{
  width: 100%;
  height: 50px;
  background: #fff;
  position: fixed;
  /* right: 0; */
  bottom: 0;
}

@media (max-width: 1300px) {
  .content{
    height: 91.5% !important;
  }
}

</style>
